import { z } from "zod";

import { useSpaceContext } from "src/components/spaces";
import { useMatches } from "src/router";

const fullscreenHandle = z.object({ isFullscreen: z.literal(true) });

/** Route `handle` for a page that takes the whole window, with no nav beside it. */
export const FULLSCREEN_ROUTE_HANDLE = {
  isFullscreen: true,
} satisfies z.infer<typeof fullscreenHandle>;

const isFullscreenHandle = (handle: unknown) =>
  fullscreenHandle.safeParse(handle).success;

/** True when a matched route declares the whole window, even inside a space, where the nav still shows beside it. */
export const useIsFullscreenRouteDeclared = () =>
  useMatches().some((match) => isFullscreenHandle(match.handle));

/** True when a matched route declares the whole window, outside a space, whose blocked page points to the nav's space switch. */
export const useIsFullscreenRoute = () => {
  const { isSpacesEnabled, isInSpace } = useSpaceContext();
  const isDeclared = useIsFullscreenRouteDeclared();
  return isDeclared && !(isSpacesEnabled && isInSpace);
};
